import { goToMenuViaSlug } from './locations';
import { editCart } from 'cart/actions';
import { clearCart } from 'cart/actions/index';
import { resetIsCartItemAvailable } from 'cart/actions/cartAvailable';
import { getOnlineOrderingUrlParams } from 'utils/url';
import { closeModal } from 'base/actions/modal';

const setCartFulfillmentOptions = () => async (dispatch, getState) => {
  const state = getState();
  const { cartWorkingCopy, cartAvailable, router } = state;

  const { locationSlug } = getOnlineOrderingUrlParams(router.location.pathname);

  // if items already in the cart are no longer available after changes to fulfillment options,
  // we need to empty the cart
  if (!cartAvailable.isAvailable) {
    await dispatch(clearCart());
    dispatch(resetIsCartItemAvailable());
  }
  await dispatch(editCart(cartWorkingCopy));
  dispatch(goToMenuViaSlug(locationSlug));
  dispatch(closeModal());
};

export default setCartFulfillmentOptions;
